import "./Components.css";
export default function Loader() {
    return (
        <div className=" bodyBGPic">
        <div className="loader"></div>
        </div>
    )
}